import React from "react";

const PhotoRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5 15.5V8C17.5 6.89543 16.6046 6 15.5 6H15.1667C14.763 6 14.3989 5.75726 14.2436 5.38462L13.5064 3.61538C13.3511 3.24274 12.987 3 12.5833 3H7.91667C7.51297 3 7.14886 3.24274 6.99359 3.61538L6.25641 5.38462C6.10114 5.75726 5.73703 6 5.33333 6H5C3.89543 6 3 6.89543 3 8V15.5C3 16.6046 3.89543 17.5 5 17.5H15.5C16.6046 17.5 17.5 16.6046 17.5 15.5Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 11.25C13.5 13.0449 12.0449 14.5 10.25 14.5C8.4551 14.5 7 13.0449 7 11.25C7 9.4551 8.4551 8 10.25 8C12.0449 8 13.5 9.4551 13.5 11.25Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(PhotoRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;